import { useAtomValue } from "jotai";
import { useEffect, useEffectEvent } from "react";
import { useSelector } from "react-redux";

import { getNodeIdExistsSelector, getNodeTypeIdSelector } from "@skilitics/nautilus-core-designer-data";

import { getIsSelectionTargetSelector } from "../state/index.ts";
import { selectedNodeIdAtom } from "./selectionAtoms.ts";

// would rather have this whole thing in a DEV guard and stripped in prod but rules-of-hooks gets in way

/** Selecting a node whose designer never said it can stand in the panel is a coding error. */
export const useWarnOnUndeclaredSelectionTarget = () => {
  const selectedNodeId = useAtomValue(selectedNodeIdAtom);
  const getIsSelectionTarget = useSelector(getIsSelectionTargetSelector);
  const getTypeId = useSelector(getNodeTypeIdSelector);
  const getNodeIdExists = useSelector(getNodeIdExistsSelector);

  const warnIfUndeclared = useEffectEvent(() => {
    if (selectedNodeId === undefined || !getNodeIdExists(selectedNodeId)) return;
    if (getIsSelectionTarget(getTypeId(selectedNodeId))) return;

    console.warn(`Node ${selectedNodeId} was selected but its designer does not declare selectionTarget.`);
  });

  useEffect(() => {
    if (!import.meta.env.DEV) return;
    warnIfUndeclared();
  }, [selectedNodeId]);
};
